
const CHECKBOX_STATES = {
    Checked: 1,       // 'Checked',
    Indeterminate: 2, // 'Indeterminate',
    Empty: 0,         // 'Empty',
};

export default CHECKBOX_STATES;